<script>
export default {
  name: "status-label",
  props: {
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    listObj: {
      list: [
        { label: "待审核", color: "#e58450" },
        { label: "已通过", color: "#5cc474" },
        { label: "审核未通过", color: "#f06052" },
        { label: "已归档", color: "#8cc64e" }
      ];
    }
  },
  render(createElement) {
    const innerHtml = this.listObj.list[this.status].label;
    return createElement("span", {
      style: {
        color: this.list[this.status].color
      },
      attrs: {
        id: "status" + this.status
      },
      domProps: {
        innerHtml
      },
      on: {
        click: () => this.status
      }
    });
  }
};
</script>

<style lang="less" scoped></style>
